module.exports = __webpack_public_path__ + "93b00da40e6662288c2395970159337a.svg";